import { render, staticRenderFns } from "./passDot.vue?vue&type=template&id=c2790d00&scoped=true"
import script from "./passDot.vue?vue&type=script&lang=js"
export * from "./passDot.vue?vue&type=script&lang=js"
import style0 from "./passDot.vue?vue&type=style&index=0&id=c2790d00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2790d00",
  null
  
)

export default component.exports